import { v4 as uuidv4 } from 'uuid'
import { ref } from 'vue'

// interface Action {
//   label: string
// }

// type Type = "success" | "error" | "warning" | "info"

// interface Message {
//   id: string
//   description: string
//   title: string
//   icon: string
//   actions: Action[],
//   closeable: boolean,
//   type: Type
// }

const messages = ref([])

export const useMessages = () => {
	function dismissMessage(id) {
		setTimeout(() => {
			const message = messages.value.find((message) => message.id === id)
			messages.value.splice(messages.value.indexOf(message), 1)
		}, 5000)
	}

	function addMessage(message) {
		message.id = uuidv4()

		messages.value.push(message)

		dismissMessage(message.id)
	}

	return {
		addMessage,
		messages,
	}
}
